export const buildColumnVisibilityFromCookie = (cookie) => {
  const visibility = [];
  // eslint-disable-next-line no-restricted-syntax,no-unused-vars
  for (const group of cookie) {
    // eslint-disable-next-line no-restricted-syntax,no-unused-vars
    for (const child of group.order) {
      if (child.visible === false) {
        visibility.push(child.id);
      }
    }
  }
  return visibility;
};
